var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"title":"Salon en vivo","hide-footer":"","size":"lg","id":"salon-mapa-en-vivo"}},[_c('salon',{attrs:{"modo":"mapa-en-vivo","salon":_vm.salon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }